import {
  Card,
  Typography,
  Input,
  Button,
  Pagination,
  Empty,
  Tooltip,
  Switch,
} from "antd";
import { DeleteOutlined, PlusOutlined, EditOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import ConfirmationModal from "../../Modal/ConfirmationModal";
import { useState, useEffect } from "react";
import SortingArrow from "../../Common/SortingArrow";
import { useDispatch } from "react-redux";
import globalRequest from "../../utils/global/globalRequest";
import * as Validation from "../../utils/helper/validation";
import * as Apis from "../../utils/helper/enum";
import toast from "react-hot-toast";
import { paginationLimit, paginationPages } from "../../utils/helper/constants";
import {
  addDeleteGetLocalStorage,
  storageKeys,
} from "../../utils/global/localData";
import { jwtDecode } from "jwt-decode";
import { changeLoader } from "../../redux/reducers/loader";
import { capitalizeName, formatDateFunction } from "../../utils/helper/utils";
import { checkPermissionAction } from "../../utils/helper/utils";
let timer = null;

const ManageCoupon = () => {
  const [list, setList] = useState([]);
  const [paginationModel, setPaginationModel] = useState(paginationLimit);
  const [inputData, setInputData] = useState({});
  const [totalRows, setTotalRows] = useState(0);
  const [itemData, setItemData] = useState(0);
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const { Search } = Input;  
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const userAccess = addDeleteGetLocalStorage(
    storageKeys?.USER_TOKEN,
    {},
    "get"
  );
  let permissionJson = [];
  if (userAccess) {
    const decoded = jwtDecode(userAccess);
    permissionJson = decoded?.user?.rolePermission?.permissionJson;
  }

  const handleDeleteOk = async () => {
    setIsDeleteModalOpen(false);
    try {
      let value = { status: "deleted" };
      let response = await globalRequest(
        Apis?.MANAGE_COUPON?.UPDATE_STATUS + "/" + itemData.id,
        "put",
        value,
        {},
        true
      );
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let msg = "Coupon deleted successfully";
        toast.success(msg, {
          duration: 2000,
        });
        getAllCoupon();
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
  };
  const handleDeleteCancel = () => {
    setIsDeleteModalOpen(false);
  };
  const handleSort = (column, order) => {
    setInputData((prev) => ({
      ...prev,
      order_by: column,
      order_type: order,
    }));
  };

  const getAllCoupon = async () => {
    dispatch(changeLoader(true));
    try {
      let params = {
        ...inputData,
        page: paginationModel?.page,
        limit: paginationModel?.limit,
      };
      let response = await globalRequest(
        Apis.MANAGE_COUPON.GET_ALL_COUPON,
        "get",
        {},
        { params: params },
        true
      );
      let apiResponse = response?.data;
      if (response?.status === 200) {
        setList(apiResponse?.data?.data);
        setTotalRows(apiResponse?.data?.paginator?.itemCount);
      } else {
        // toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
    dispatch(changeLoader(false));
  };

  useEffect(() => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      getAllCoupon();
    }, 400);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputData, paginationModel]);

  const handleStatusChange = async (item) => {
    try {
      let value = { status: item.status === "active" ? "inactive" : "active" };
      let response = await globalRequest(
        Apis?.MANAGE_COUPON?.UPDATE_STATUS + "/" + item.id,
        "put",
        value,
        {},
        true
      );
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let msg = "Coupon active successfully";
        if (item.status === "active") msg = "Coupon inactive successfully";
        toast.success(msg, {
          duration: 2000,
        });
        getAllCoupon();
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
  };

  return (
    <>
      <Card>
        <div className="block sm:flex justify-between mb-4 gap-5">
          <div className="">
            <Typography className="text-xl font-semibold" align={"left"}>
              Coupon Management
            </Typography>
          </div>
          <div>
            <Search
              placeholder="Search "
              style={{
                width: 250,
              }}
              className="mx-1.5 cursor-pointer my-3 sm:my-0"
              onChange={(e) => {
                let value = Validation.strFormat(e.target.value, "trim");
                setInputData((prev) => ({ ...prev, search: value }));
                setPaginationModel((prev) => ({ ...prev, page: 1 }));
              }}
            />
            {checkPermissionAction("Manage Coupon", permissionJson, "add") ? (
              <Button
                type="primary"
                size={14}
                icon={<PlusOutlined />}
                className="cursor-pointer"
                onClick={() => navigate("/manage-coupon/create-coupon")}
              >
                New Coupon
              </Button>
            ) : null}
          </div>
        </div>
        <div className="relative overflow-x-auto">
          <table className="w-full  text-left	 text-sm  text-gray-500">
            <thead className=" text-gray-700 capitalize text-xs	 bg-gray-50">
              <tr>
                <th scope="col" className="px-3 py-3 whitespace-nowrap">
                  Coupon Code{" "}
                  <SortingArrow
                    onSort={(order) => handleSort("couponCode", order)}
                  />
                </th>
                <th scope="col" className="px-3 py-3 whitespace-nowrap">
                  Discount Type{" "}
                  <SortingArrow
                    onSort={(order) => handleSort("discountType", order)}
                  />
                </th>
                <th scope="col" className="px-3 py-3 whitespace-nowrap">
                  Discount Amount{" "}
                  <SortingArrow
                    onSort={(order) => handleSort("couponAmount", order)}
                  />
                </th>
                <th scope="col" className="px-3 py-3 whitespace-nowrap">
                  Valid To{" "}
                  <SortingArrow
                    onSort={(order) => handleSort("couponExpiryDate", order)}
                  />
                </th>
                <th scope="col" className="px-3 py-3 whitespace-nowrap">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {list?.length ? (
                list?.map((item, index) => (
                  <tr className="bg-white border-b" key={index}>
                    <td className="px-3 py-4 vertical-top whitespace-nowrap">
                      {item?.couponCode}
                    </td>
                    <td className="px-3 py-4 vertical-top whitespace-nowrap">
                      { item?.discountType==='flat_cap' ? 'Flat Cap' : capitalizeName(item?.discountType)}
                    </td>
                    <td className="px-3 py-4 vertical-top whitespace-nowrap">
                      {item?.couponAmount}
                    </td>
                    <td className="px-3 py-4 vertical-top whitespace-nowrap">
                      {formatDateFunction(item?.couponExpiryDate, "dd-mm-yyyy")}
                    </td>
                    <td className="px-3 py-4 text-left whitespace-nowrap vertical-top">
                      <Tooltip title="Edit permission">
                        <EditOutlined
                          onClick={() => {
                            if (
                              checkPermissionAction(
                                "Manage Coupon",
                                permissionJson,
                                "edit"
                              )
                            ) {
                              navigate("/manage-coupon/edit-coupon/" + item.id);
                            }
                          }}
                          className={`mx-1.5 cursor-pointer ${
                            !checkPermissionAction(
                              "Manage Coupon",
                              permissionJson,
                              "edit"
                            )
                              ? "text-gray-400 cursor-not-allowed"
                              : ""
                          }`}
                        />
                      </Tooltip>
                      <Tooltip title="Delete">
                        <DeleteOutlined
                          className={`mx-1.5 cursor-pointer ${
                            !checkPermissionAction(
                              "Manage Coupon",
                              permissionJson,
                              "delete"
                            )
                              ? "text-gray-400 cursor-not-allowed"
                              : ""
                          }`}
                          onClick={() => {
                            if (
                              checkPermissionAction(
                                "Manage Coupon",
                                permissionJson,
                                "delete"
                              )
                            ) {
                              setIsDeleteModalOpen(true);
                              setItemData(item);
                            }
                          }}
                        />
                      </Tooltip>
                      <Switch
                        size="small"
                        checked={item?.status === "active" ? true : false}
                        onChange={() => {
                          handleStatusChange(item);
                        }}
                        disabled={
                          !checkPermissionAction(
                            "Manage Coupon",
                            permissionJson,
                            "update_status"
                          )
                        }
                      />
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={13} className="text-center mt-3">
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                  </td>
                </tr>
              )}
              {/* <tr className="bg-white border-b">
                <td className="px-3 py-4 vertical-top whitespace-nowrap">
                  1000
                </td>
                <td className="px-3 py-4 vertical-top whitespace-nowrap">
                  flat
                </td>
                <td className="px-3 py-4 vertical-top whitespace-nowrap">
                  100
                </td>
                <td className="px-3 py-4 vertical-top whitespace-nowrap">
                  December 27, 2023
                </td>
                <td className="px-3 py-4 text-left whitespace-nowrap vertical-top">
                  <Tooltip title="Edit permission">
                    <EditOutlined className={`mx-1.5 cursor-pointer`} />
                  </Tooltip>
                  <Tooltip title="Delete">
                    <DeleteOutlined
                      className={`mx-1.5 cursor-pointer `}
                      onClick={() => {
                        setIsDeleteModalOpen(true);
                      }}
                    />
                  </Tooltip>
                  <Switch size="small" defaultChecked />
                </td>
              </tr> */}
            </tbody>
          </table>
        </div>

        {list?.length ? (
          <div className="text-right mt-4">
            <Pagination
              defaultCurrent={1}
              total={totalRows}
              pageSizeOptions={paginationPages}
              showSizeChanger={true}
              current={paginationModel?.page}
              pageSize={paginationModel?.limit}
              onChange={(page) =>
                setPaginationModel((prev) => ({ ...prev, page: page }))
              }
              onShowSizeChange={(current, size) =>
                setPaginationModel((prev) => ({ ...prev, limit: size }))
              }
            />
          </div>
        ) : null}
      </Card>

      {/* delete modal */}
      {isDeleteModalOpen && (
        <ConfirmationModal
          ConfirmationHeading="Delete"
          ConfirmationParagraph="Are you sure you want to delete this Coupon?"
          isOpen={isDeleteModalOpen}
          onOk={handleDeleteOk}
          onCancel={handleDeleteCancel}
        />
      )}
    </>
  );
};
export default ManageCoupon;
